class InviteGenerator {
  constructor() {
    this.canvas = null;
    this.ctx = null;
    this.templateImage = new Image();
    this.templateImage.crossOrigin = 'anonymous';
  }

  async generateInvite(theme = 'space') {
    const formData = this.getFormData();
    
    if (!formData.partyHostName) {
      alert('Please enter a Party Host Name for the invitation');
      return;
    }

    try {
      let templateUrl;
      switch(theme) {
        case 'space':
          templateUrl = 'https://cdn.shopify.com/s/files/1/0632/3204/9231/files/A5_-_7.png?v=1756285271';
          break;
        case 'dino':
          templateUrl = 'https://cdn.shopify.com/s/files/1/0632/3204/9231/files/A5_-_16.png?v=1756289408';
          break;
        case 'birthday':
          templateUrl = 'https://cdn.shopify.com/s/files/1/0632/3204/9231/files/A5_-_15.png?v=1756290284';
          break;
        default:
          templateUrl = 'https://cdn.shopify.com/s/files/1/0632/3204/9231/files/A5_-_7.png?v=1756285271';
      }
      
      console.log('Loading template:', templateUrl);
      await this.loadTemplate(templateUrl);
      this.setupCanvas();
      this.drawTemplate();
      this.drawText(formData, theme);
      this.downloadPDF('invite', theme);
    } catch (error) {
      console.error('Error generating invite:', error);
      alert('There was an error generating your invitation. Please try again.');
    }
  }

  async generateThankYouNote(theme = 'space') {
    const formData = this.getFormData();
    
    if (!formData.partyHostName || !formData.guestName) {
      alert('Please enter both Party Host Name and Guest Name for the thank you note');
      return;
    }

    try {
      let templateUrl;
      switch(theme) {
        case 'space':
          templateUrl = 'https://cdn.shopify.com/s/files/1/0632/3204/9231/files/A5_-_7.png?v=1756285271';
          break;
        case 'dino':
          templateUrl = 'https://cdn.shopify.com/s/files/1/0632/3204/9231/files/A5_-_16.png?v=1756289408';
          break;
        case 'birthday':
          templateUrl = 'https://cdn.shopify.com/s/files/1/0632/3204/9231/files/A5_-_15.png?v=1756290284';
          break;
        default:
          templateUrl = 'https://cdn.shopify.com/s/files/1/0632/3204/9231/files/A5_-_7.png?v=1756285271';
      }
      
      console.log('Loading thank you template:', templateUrl);
      await this.loadTemplate(templateUrl);
      this.setupCanvas();
      this.drawTemplate();
      this.drawThankYouText(formData, theme);
      this.downloadPDF('thank-you', theme);
    } catch (error) {
      console.error('Error generating thank you note:', error);
      alert('There was an error generating your thank you note. Please try again.');
    }
  }

  getFormData() {
    return {
      partyHostName: document.getElementById('party-host-name')?.value || '',
      guestName: document.getElementById('guest-name')?.value || '',
      event: document.getElementById('invite-event')?.value || 'birthday party',
      where: 'Hamleys Fourways',
      date: document.getElementById('invite-date')?.value || '[Event Date]',
      time: document.getElementById('invite-time')?.value || '[Timeslot booked]',
      rsvp: document.getElementById('invite-rsvp')?.value || '[Date by which to RSVP]',
      rsvpTo: document.getElementById('invite-rsvp-to')?.value || 'Cell phone number/email address'
    };
  }

  loadTemplate(imageUrl) {
    return new Promise((resolve, reject) => {
      this.templateImage.onload = () => resolve();
      this.templateImage.onerror = () => reject(new Error('Failed to load template image'));
      this.templateImage.src = imageUrl;
    });
  }

  setupCanvas() {
    if (!this.canvas) {
      this.canvas = document.createElement('canvas');
      this.ctx = this.canvas.getContext('2d');
    }
    
    this.canvas.width = this.templateImage.width;
    this.canvas.height = this.templateImage.height;
  }

  drawTemplate() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.drawImage(this.templateImage, 0, 0);
  }

  drawText(formData, theme) {
    const canvasWidth = this.canvas.width;
    const canvasHeight = this.canvas.height;
    
    this.ctx.fillStyle = '#FFFFFF';
    this.ctx.textAlign = 'center';

    // Set font style
    this.ctx.font = '700 60px Poppins, sans-serif';

    // Use same text and layout for all themes
    const titleText = "You're Invited";
    const mainText = `Play all day at ${formData.partyHostName}'s birthday party!`;
    const textYPos = canvasHeight * 0.45;
    const lineSpacing = 30;

    // "You're Invited" title - centered at top
    this.ctx.fillText(titleText, canvasWidth * 0.5, textYPos);

    // Main invitation text - centered below title
    this.ctx.font = '40px Poppins, sans-serif';
    this.ctx.fillText(mainText, canvasWidth * 0.5, textYPos + lineSpacing + 33);
    
    this.ctx.textAlign = 'left';
    const leftMargin = canvasWidth * 0.15;
    const valueMargin = canvasWidth * 0.35;
    let startY = canvasHeight * 0.60;
    const verticalGap = canvasHeight * 0.05;

    // What field
    this.ctx.font = 'bold 30px Poppins, sans-serif';
    this.ctx.fillText('What :', leftMargin, startY);
    this.ctx.font = '30px Poppins, sans-serif';
    this.ctx.fillText(formData.event || '[Event Name]', valueMargin, startY);

    // Where field  
    startY += verticalGap;
    this.ctx.font = 'bold 30px Poppins, sans-serif';
    this.ctx.fillText('Where :', leftMargin, startY);
    this.ctx.font = '30px Poppins, sans-serif';
    this.ctx.fillText(formData.where, valueMargin, startY);

    // Date field
    startY += verticalGap;
    this.ctx.font = 'bold 30px Poppins, sans-serif';
    this.ctx.fillText('Date :', leftMargin, startY);
    this.ctx.font = '30px Poppins, sans-serif';
    this.ctx.fillText(formData.date, valueMargin, startY);

    // Time field
    startY += verticalGap;
    this.ctx.font = 'bold 30px Poppins, sans-serif';
    this.ctx.fillText('Time :', leftMargin, startY);
    this.ctx.font = '30px Poppins, sans-serif';
    this.ctx.fillText(formData.time, valueMargin, startY);

    // RSVP Date field
    startY += verticalGap;
    this.ctx.font = 'bold 30px Poppins, sans-serif';
    this.ctx.fillText('RSVP Date :', leftMargin, startY);
    this.ctx.font = '30px Poppins, sans-serif';
    this.ctx.fillText(formData.rsvp, valueMargin, startY);

    // RSVP to field
    startY += verticalGap;
    this.ctx.font = 'bold 30px Poppins, sans-serif';
    this.ctx.fillText('RSVP to :', leftMargin, startY);
    this.ctx.font = '30px Poppins, sans-serif';
    this.ctx.fillText(formData.rsvpTo, valueMargin, startY);
  }

  drawThankYouText(formData, theme) {
    const canvasWidth = this.canvas.width;
    const canvasHeight = this.canvas.height;
    
    this.ctx.fillStyle = '#FFFFFF';
    this.ctx.textAlign = 'center';

    // Use same text and layout for all themes (space theme layout)
    const titleLine1 = 'Thank you';
    const titleLine2 = 'for sharing smiles,';
    const titleLine3 = 'giggles & fun with us.';
    const toText = `To: ${formData.guestName}`;
    const fromText = `From: ${formData.partyHostName}`;
    const yPos1 = canvasHeight * 0.45;
    const yPos2 = canvasHeight * 0.52;
    const yPos3 = canvasHeight * 0.58;
    const yPos4 = canvasHeight * 0.70;
    const yPos5 = canvasHeight * 0.74;

    // Main thank you message
    this.ctx.font = '700 70px Poppins, sans-serif';
    this.ctx.fillText(titleLine1, canvasWidth * 0.5, yPos1);
    this.ctx.fillText(titleLine2, canvasWidth * 0.5, yPos2);
    this.ctx.fillText(titleLine3, canvasWidth * 0.5, yPos3);

    // To and From fields
    this.ctx.font = 'bold 30px Poppins, sans-serif';
    this.ctx.fillText(toText, canvasWidth * 0.5, yPos4);
    this.ctx.fillText(fromText, canvasWidth * 0.5, yPos5);
  }

  async downloadPDF(type = 'invite', theme = 'space') {
    try {
      const canvas = this.canvas;
      const imgData = canvas.toDataURL('image/png');
      
      const { jsPDF } = window.jspdf;
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a5'
      });
      
      pdf.addImage(imgData, 'PNG', 0, 0, 148, 210);
      
      const filename = `${theme}-${type}-${Date.now()}.pdf`;
      
      pdf.save(filename);
      
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('There was an error generating the PDF. Please try again.');
    }
  }
}

// Initialize invite generator
document.addEventListener('DOMContentLoaded', function() {
  const inviteGenerator = new InviteGenerator();
  
  // Add click handlers for all buttons
  const allButtons = document.querySelectorAll('button');
  allButtons.forEach((button) => {
    const buttonText = button.textContent ? button.textContent.trim() : '';
    
    if (buttonText === 'Generate Invite') {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        console.log('Generate Invite button clicked');
        
        const cardContainer = this.closest('[id*="_party"]');
        let theme = 'space'; // Default theme
        
        console.log('Button element:', this);
        console.log('Card container found:', cardContainer);
        
        if (cardContainer) {
            const themeId = cardContainer.id;
            console.log('Found theme ID:', themeId);
            console.log('Card container classes:', cardContainer.className);
            
            if (themeId === 'space_party') {
                theme = 'space';
                console.log('Setting theme to space');
            } else if (themeId === 'dino_party') {
                theme = 'dino';
                console.log('Setting theme to dino');
            } else if (themeId === 'classic_birthday_party') {
                theme = 'birthday';
                console.log('Setting theme to birthday');
            } else {
                console.log('No matching theme ID found, using default space');
            }
        } else {
            console.log('No card container found');
        }
        
        console.log('Final theme selected:', theme);
        inviteGenerator.generateInvite(theme);
      });
    } else if (buttonText === 'Thank You Note') {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        console.log('Thank You Note button clicked');
        
        const cardContainer = this.closest('[id*="_party"]');
        let theme = 'space'; // Default theme
        
        console.log('Button element:', this);
        console.log('Card container found:', cardContainer);
        
        if (cardContainer) {
            const themeId = cardContainer.id;
            console.log('Found theme ID:', themeId);
            console.log('Card container classes:', cardContainer.className);
            
            if (themeId === 'space_party') {
                theme = 'space';
                console.log('Setting theme to space');
            } else if (themeId === 'dino_party') {
                theme = 'dino';
                console.log('Setting theme to dino');
            } else if (themeId === 'classic_birthday_party') {
                theme = 'birthday';
                console.log('Setting theme to birthday');
            } else {
                console.log('No matching theme ID found, using default space');
            }
        } else {
            console.log('No card container found');
        }
        
        console.log('Final theme selected:', theme);
        inviteGenerator.generateThankYouNote(theme);
      });
    }
  });
});